import { Router } from '../router.js';

export interface PageTransformMetadata {
  pageId: string;
  pageProperties?: Record<string, any>;
}

export function registerDynamicPageTransform(
  router: Router,
  source: string,
  pagesMetadata: Record<string, PageTransformMetadata>,
) {
  const logger = router.logger.extend('page-transform');
  router.registerTransform('page', (event, payload) => {
    const pageMetadata = pagesMetadata[window.location.pathname];
    if (pageMetadata == null) {
      logger.warn('PAGE_NOT_FOUND', () => ({
        pagePath: window.location.pathname,
      }));
      return payload;
    }
    return {
      ...payload,
      properties: {
        source,
        pageId: pageMetadata.pageId,
        ...pageMetadata.pageProperties,
        ...payload.properties,
      },
    };
  });
}

export function registerPageTransform(
  router: Router,
  source: string,
  pageId: string,
  pageProperties: Record<string, any>,
) {
  router.registerTransform('page', (event, payload) => {
    return {
      ...payload,
      properties: {
        source,
        pageId,
        ...pageProperties,
        ...payload.properties,
      },
    };
  });
}
